const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Coach Exercises
export const getCoachExercises = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${API_URL}/coach-fitness/exercises${query ? `?${query}` : ''}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch exercises');
  return response.json();
};

export const createCoachExercise = async (data) => {
  const response = await fetch(`${API_URL}/coach-fitness/exercises`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to create exercise');
  return response.json();
};

export const updateCoachExercise = async (id, data) => {
  const response = await fetch(`${API_URL}/coach-fitness/exercises/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update exercise');
  return response.json();
};

export const deleteCoachExercise = async (id) => {
  const response = await fetch(`${API_URL}/coach-fitness/exercises/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to delete exercise');
  return response.json();
};

export const publishCoachExercise = async (id) => {
  const response = await fetch(`${API_URL}/coach-fitness/exercises/${id}/publish`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to publish exercise');
  return response.json();
};

// Coach Workouts
export const getCoachWorkouts = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${API_URL}/coach-fitness/workouts${query ? `?${query}` : ''}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch workouts');
  return response.json();
};

export const createCoachWorkout = async (data) => {
  const response = await fetch(`${API_URL}/coach-fitness/workouts`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to create workout');
  return response.json();
};

export const updateCoachWorkout = async (id, data) => {
  const response = await fetch(`${API_URL}/coach-fitness/workouts/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update workout');
  return response.json();
};

export const deleteCoachWorkout = async (id) => {
  const response = await fetch(`${API_URL}/coach-fitness/workouts/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to delete workout');
  return response.json();
};

export const publishCoachWorkout = async (id) => {
  const response = await fetch(`${API_URL}/coach-fitness/workouts/${id}/publish`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to publish workout');
  return response.json();
};

export const cloneCoachWorkout = async (workoutId) => {
  const response = await fetch(`${API_URL}/coach-fitness/workouts/${workoutId}/clone`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to clone workout');
  return response.json();
};

// Coach Programs
export const getCoachPrograms = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${API_URL}/coach-fitness/programs${query ? `?${query}` : ''}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch programs');
  return response.json();
};

export const createCoachProgram = async (data) => {
  const response = await fetch(`${API_URL}/coach-fitness/programs`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to create program');
  return response.json();
};

export const updateCoachProgram = async (id, data) => {
  const response = await fetch(`${API_URL}/coach-fitness/programs/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update program');
  return response.json();
};

export const deleteCoachProgram = async (id) => {
  const response = await fetch(`${API_URL}/coach-fitness/programs/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to delete program');
  return response.json();
};

export const publishCoachProgram = async (id) => {
  const response = await fetch(`${API_URL}/coach-fitness/programs/${id}/publish`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to publish program');
  return response.json();
};

export const cloneCoachProgram = async (programId) => {
  const response = await fetch(`${API_URL}/coach-fitness/programs/${programId}/clone`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to clone program');
  return response.json();
};

export const cloneCoachExercise = async (exerciseId) => {
  const response = await fetch(`${API_URL}/coach-fitness/exercises/${exerciseId}/clone`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to clone exercise');
  return response.json();
};

// Exercise Library (system + own + public approved)
export const getExerciseLibrary = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${API_URL}/coach-fitness/exercises/library${query ? `?${query}` : ''}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch exercise library');
  return response.json();
};

// Client Assignment
export const assignToClient = async (clientId, data) => {
  const response = await fetch(`${API_URL}/coach-fitness/clients/${clientId}/assign`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to assign to client');
  return response.json();
};

export const getClientSchedule = async (clientId, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${API_URL}/coach-fitness/clients/${clientId}/schedule${query ? `?${query}` : ''}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch client schedule');
  return response.json();
};

export const getClientProgress = async (clientId) => {
  const response = await fetch(`${API_URL}/coach-fitness/clients/${clientId}/progress`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch client progress');
  return response.json();
};

// Coach Stats
export const getCoachFitnessStats = async () => {
  const response = await fetch(`${API_URL}/coach-fitness/stats`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch stats');
  return response.json();
};

// Fitness Page Settings
export const updateFitnessPageSettings = async (settings) => {
  const response = await fetch(`${API_URL}/affiliate/fitness-page-settings`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(settings)
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update settings');
  return response.json();
};
